import { useState } from 'react';

import bridge from '~/utils/bridge';
import checkPhone from '~/utils/valid/check-phone';

const INIT = {
  email: '',
  name: '',
  phone: '',
  agree: null,
};

function useForm() {
  const [isSending, setSending] = useState(false);
  const [state, setState] = useState(INIT);

  function changeState(e) {
    const regexNumber = /[^0-9]/g;
    const { name, value } = e.currentTarget;

    if (name === 'phone' && !(!regexNumber.test(value) && value.length < 12)) return false;

    setState(prev => {
      return {
        ...prev,
        [name]: value,
      }
    });
  }

  function close() {
    bridge.ios(function (call) {
      console.log('ios');
      call.callHandler('ObjC Echo', {
       cmd: 'finishActivity',
     })
    })

    bridge.android(function (call) {
      console.log('android');
      call.finishActivity();
    });

    bridge.web(function () {
      console.log('web')
    });
  }
  
  async function submit() {
    if (isSending) return false;

    if (!state.agree || state.agree === 'false') return alert('개인정보 이용 및 처리에 동의해주세요.');
    if (state.email === '') return alert('회원ID를 입력해주세요.');
    if (state.name === '') return alert('이름을 입력해주세요.');
    if (state.phone === '') return alert('연락처를 입력해주세요.');

    setSending(true);

    try {
      return alert('종료된 이벤트 입니다.');
      // await apiCall.post('/api/v2/events/apply-20210127', {
      //   email: state.email,
      //   phone: state.phone,
      //   name: state.name,
      // }, "pro");
      alert('참여해주셔서 감사합니다.\n살고 싶은 방을 다방에서 확인해보세요.');
      setSending(false);
      close();

    } catch(err) {
      setSending(false);
      console.log(err);
      alert(err?.msg ?? '서버에러가 발생했습니다.');
    }
  }

  return { state, isSending, changeState, submit };
}

export default useForm;
